import { render, staticRenderFns } from "./Ownership.vue?vue&type=template&id=2d3a286b&scoped=true"
import script from "./Ownership.vue?vue&type=script&lang=js"
export * from "./Ownership.vue?vue&type=script&lang=js"
import style0 from "./Ownership.vue?vue&type=style&index=0&id=2d3a286b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a286b",
  null
  
)

export default component.exports